import type { ReactNode } from "react";

const marketData = [
  { label: "TAM (UK immigration)", value: "£3.29B" },
  { label: "Applications per year", value: "4.2M" },
  { label: "SAM (professionally represented)", value: "£592M" },
  { label: "SOM (10% penetration)", value: "£59M" },
  { label: "Regulated firms (UK)", value: "5,089" },
];

const tailwinds: ReactNode[] = [
  <>Massively fragmented: 5,089 small firms, most 1-5 people, many owners <strong className="font-medium text-[var(--color-fg)]">looking to exit</strong></>,
  <>EU AI Act (Aug 2026): raises the compliance bar. Small firms can&apos;t meet it alone</>,
  <>US VCs deploying: $B+ flowing into AI roll-ups. UK market is wide open</>,
  <>Already live in 3 countries: UK, AU/NZ (ProActive Legal), Singapore in pipeline</>,
];

export function V2MarketSlide({ isActive: _ }: { isActive: boolean }) {
  return (
    <div className="flex flex-col h-full">
      <h2 className="text-[32px] font-light tracking-tight mb-5 font-[family-name:var(--font-heading)]">
        A fragmented market.<br />Ready for consolidation
      </h2>

      <div className="grid grid-cols-2 gap-8">
        {/* Market data */}
        <div>
          <div className="text-[12px] font-[family-name:var(--font-mono)] font-bold text-[var(--color-accent)] uppercase tracking-[0.1em] mb-4 pb-2 border-b border-[var(--color-border)]">
            UK Immigration Legal Services
          </div>
          <div className="space-y-2">
            {marketData.map((d, i) => (
              <div
                key={d.label}
                className="flex justify-between items-baseline text-[12px] pb-2"
                style={{ borderBottom: i < marketData.length - 1 ? "1px solid var(--color-border)" : "none" }}
              >
                <span className="text-[var(--color-fg-tertiary)] font-[family-name:var(--font-mono)]">{d.label}</span>
                <span className="font-bold text-[var(--color-fg)]">{d.value}</span>
              </div>
            ))}
          </div>
        </div>

        {/* Tailwinds */}
        <div>
          <div className="text-[12px] font-[family-name:var(--font-mono)] font-bold text-[var(--color-accent)] uppercase tracking-[0.1em] mb-4 pb-2 border-b border-[var(--color-border)]">
            Tailwinds
          </div>
          <div className="space-y-3">
            {tailwinds.map((t, i) => (
              <div key={i} className="flex items-start gap-2">
                <span className="w-1 h-1 rounded-full bg-[var(--color-accent)] shrink-0 mt-1.5" />
                <p className="text-[12px] text-[var(--color-fg-secondary)] leading-relaxed">{t}</p>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="flex items-end gap-6 mt-auto mb-8 pb-4 border-b border-[var(--color-border)]">
        <div className="shrink-0">
          <div className="text-[28px] font-light tracking-tight font-[family-name:var(--font-heading)]">£24.4B</div>
          <div className="text-[9px] font-[family-name:var(--font-mono)] uppercase tracking-wider text-[var(--color-fg-tertiary)]">Global TAM</div>
        </div>
        <div>
          <p className="text-[12px] text-[var(--color-fg-secondary)] font-light">
            Every fragmented firm is also an untapped data source.
          </p>
          <p className="text-[12px] font-medium text-[var(--color-fg)] mt-0.5">
            Consolidation doesn&apos;t just capture revenue. It captures the training data that makes agents better.
          </p>
        </div>
      </div>
    </div>
  );
}
